import { render } from "./Nomenclatoare.vue?vue&type=template&id=117beeaf"
import script from "./Nomenclatoare.vue?vue&type=script&lang=js"
export * from "./Nomenclatoare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__